import { render } from "./bad_bill.vue?vue&type=template&id=1fb1da4c&scoped=true"
import script from "./bad_bill.vue?vue&type=script&lang=js"
export * from "./bad_bill.vue?vue&type=script&lang=js"

import "./bad_bill.vue?vue&type=style&index=0&id=1fb1da4c&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb1da4c"]])

export default __exports__